// AUTO-GENERATED — do not edit manually. your changes may be overwritten
// Run `pnpm sync-roles` to regenerate from the database.

export const AppRoles = {
  prism: {
    /** Administrator — Full administrative access */
    admin: 'Prism.Admin',
    /** Prism Executive — Role for Prism Executives  */
    executive: 'Prism.Executive',
    /** Prism - Lease Manager */
    leaseManager: 'Prism.Lease Manager',
    /** MarketValue — Can access market value features */
    marketValue: 'Prism.MarketValue',
  },
  prismInvestment: {
    /** Executive — Executive oversight of investment transactions */
    executive: 'PrismInvestment.Executive',
    /** Finance Approver — Can approve finance lead assignments */
    financeApprover: 'PrismInvestment.Finance Approver',
    /** Foreign Property Viewer — Can see foreign acquisitions */
    foreignPropertyViewer: 'PrismInvestment.Foreign Property Viewer',
    /** GIS Analyst — Read transactions for GIS mapping */
    gisAnalyst: 'PrismInvestment.GIS Analyst',
    /** Prism Investment Admin — Manage users within the Prism Investment App */
    investAdmin: 'PrismInvestment.Invest Admin',
    /** Investment Analyst — Read transactions, update COC & IRR */
    investmentAnalyst: 'PrismInvestment.Investment Analyst',
    /** Investment Associate — Read, write/update, edit anything in Investment */
    investmentAssociate: 'PrismInvestment.Investment Associate',
    /** Investment Director — Director-level oversight and qualification */
    investmentDirector: 'PrismInvestment.Investment Director',
    /** Investment Manager — Create, Edit, Delete, etc Transactions */
    investmentManager: 'PrismInvestment.Investment Manager',
    /** Investment Price Viewer — Can view prices in reports within Prism Investment */
    investmentPriceViewer: 'PrismInvestment.Investment Price Viewer',
    /** Investment Report Viewer */
    investmentReportViewer: 'PrismInvestment.Investment Report Viewer',
    /** Investment Transition Admin — Transitional admin role for Jarvis integration and transaction viewing */
    investmentTransitionAdmin: 'PrismInvestment.Investment Transition Admin',
    /** Land Approver — Can approve land/transaction lead assignments */
    landApprover: 'PrismInvestment.Land Approver',
    /** Lease Manager Investments */
    leaseManager: 'PrismInvestment.Lease Manager',
    /** Market View */
    marketView: 'PrismInvestment.Market View',
    /** Operations Approver — Can qualify/decline transactions at operations level */
    operationsApprover: 'PrismInvestment.Operations Approver',
  },
  prismLand: {
    /** Land Admin — Can manage users within the Land app */
    landAdmin: 'PrismLand.Land Admin',
    /** Land Viewer */
    landViewer: 'PrismLand.Land Viewer',
  },
} as const;

type NestedValues<T> = T extends Record<string, infer V>
  ? V extends string ? V : NestedValues<V>
  : never;

/** Union of all known AppRole name strings. */
export type AppRoleName = NestedValues<typeof AppRoles>;
